import { combineReducers } from '@reduxjs/toolkit'
import undoable from 'redux-undo'
import { entitiesReducers } from 'apps/studio/store/reducers/entities'
import {
  addPdf,
  replacePdf,
  initializePdfPages,
  backFillPagesAndLayouts,
} from 'apps/studio/store/actions/sharedActions'
import { appSettingsReducer } from 'apps/studio/store/reducers/settings/appSettings'
import {
  studioSettingsReducer,
  studioSettingsActions,
} from 'apps/studio/store/reducers/settings/studioSettings'
import { typesReducers } from 'apps/studio/store/reducers/types'
import { pdfPageMetaActions } from 'apps/studio/store/reducers/pdfPageMeta'
import { builderReducers } from 'apps/formsCreationKit/store/reducers'
import { clientSettingsReducer } from 'apps/studio/store/reducers/settings/clientSettings'
const { entities, settings, types, ...importedBuilderReducers } =
  builderReducers
const { addPageMeta, updatePageMeta, removePageMeta } = pdfPageMetaActions
const { setTableWarningDisplayed } = studioSettingsActions

const reducers = {
  ...importedBuilderReducers,
  entities: undoable(entitiesReducers, {
    ignoreInitialState: true,
    filter: action => {
      const excludedActions = [
        addPageMeta.type,
        updatePageMeta.type,
        removePageMeta.type,
        setTableWarningDisplayed.type,
      ]
      if (excludedActions.includes(action.type)) {
        return false
      } else if (
        action.type === backFillPagesAndLayouts.type &&
        !action.payload?.replacingPdf
      ) {
        // This should only be filtered if we are backfilling on PDF load for an old form pre-layouts,
        // aka when replacingPdf is false, as that should not be undoable.
        return false
      }
      return true
    },
    groupBy: action => {
      if (
        action.type === addPdf.type ||
        action.type === initializePdfPages.type
      ) {
        return 'addPdf'
      }
      if (
        action.type === replacePdf.type ||
        (action.type === backFillPagesAndLayouts.type &&
          action.payload?.replacingPdf)
      ) {
        return 'replacePdf'
      }
      return null
    },
  }),
  settings: appSettingsReducer,
  types: typesReducers,
  studioSettings: studioSettingsReducer,
  clientSettings: clientSettingsReducer,
}

export default combineReducers(reducers)
